export type CsvResourceTypes = 'brandfolder' | 'collection';

// intentionally plural
export enum CsvContextsEnum {
  // /bulk_management#csv_upload
  Metasheets = 'metasheets',
  // /bulk_management#translations
  Translations = 'translations'
}

// capitalized because these refer to Rails classes
// intentionally singular
export enum CsvActionableTypesEnum {
  Asset = 'Asset',
  Label = 'Label',
  Section = 'Section'
}

export interface CsvOptionsBase {
  context: CsvContextsEnum;
  actionableType?: CsvActionableTypesEnum;
}
